import { Theme } from "@astryxdesign/core";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { hireosTheme } from "@shared/theme/hireos";

// Fonts are self-hosted via @font-face in public/fonts.css (#117), linked by
// build.ts — the @fontsource CSS imports base64-inlined the woff2 into the
// CSS bundle.
import "./styles.css";
import { ToastLayer } from "./components/ui/Toast";
import { AuthProvider } from "./lib/auth";
import { router } from "./router";

declare const __SENTRY_DSN__: string | undefined;

if (typeof __SENTRY_DSN__ !== "undefined" && __SENTRY_DSN__) {
  Sentry.init({
    dsn: __SENTRY_DSN__,
    environment: "admin",
  });
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <Theme theme={hireosTheme} mode="light">
      <ToastLayer>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastLayer>
    </Theme>
  </StrictMode>,
);
